function createLogicString(baseItem) {
  if(baseItem.filterType !== 'filter') {
    // Return Empty String when there are no filters in a logic grouping
    if(baseItem.filters.length === 0) {
      if(baseItem.isAnd) {
        return "[Empty AND Group]"
      }
      return "[Empty OR Group]"
    }

    // Create Logic String
    let logicString = []
    for(let item of baseItem.filters) {
      logicString.push(createLogicString(item))
    }
    return `(${logicString.join(baseItem.isAnd?" and ": " or ")})`
  }
  else {
    return baseItem.label
  }
}

export function buildLogicString(filterList) {
  let logicStringArray = []
  for (let item of filterList) {
    logicStringArray.push(createLogicString(item))
  }
  return logicStringArray.join(" and ")
}


// WEBPACK FOOTER //
// ./src/views/AudienceBuilder/util/createLogicString.js